$(document).ready(function() {
  $('.p-homeContact__item').click(function() {
    $('#selectElement').val('contact');
  });

  $('#submitButton').click(function() {
    $('#selectElement').val('recruit');
  });
});